module.exports = __webpack_public_path__ + "static/PME_Lider_2025_2D_cores-0e62cb071abde27dc3205b3360111acc.png";